import {normalize} from './dataAccess';

export function normalizeTeam(team) {
    team.teamCompanyUsers = team.teamCompanyUsers.map((teamCompanyUser) => normalize(teamCompanyUser));
    return team;
}
